export default {
      id: "icon-autotest-usage",
      viewBox: "0 0 27.442 42.131",
      url: __webpack_public_path__ + "icons.svg#icon-autotest",
      toString: function () {
        return this.url;
      }
    }